<template>
  <el-dialog
    custom-class="import-dialog"
    title="添加分组"
    :visible="visible"
    @close="close"
  >
    <div class="p20">
      <div class="flex flex-between item-center">
        <el-radio-group
          class="mb10"
          size="small"
          v-model="switchType"
          @change="switchTab"
        >
          <el-radio-button label="goodsList">营销商品</el-radio-button>
          <el-radio-button label="groupList">商品分组</el-radio-button>
        </el-radio-group>
      
      <div class="table-panel flex flex-end">
        <el-input
          class="mr10"
          size="small"
          v-model="gameName"
          placeholder="请输入名称"
          v-if="switchType==='goodsList'"
        ></el-input>
        <el-input
          class="mr10"
          size="small"
          v-model="groupName"
          placeholder="请输入分组名称"
          v-if="switchType==='groupList'"
        ></el-input>
        <el-button size="small" type="primary" @click="search">查询</el-button>
      </div>
      </div>
      <div class="table-wrapper" v-if="switchType==='goodsList'">
        <el-table
          @current-change="getCheckedEmployee"
          highlight-current-row
          :data="goodsList"
          key="goodsList"
          style="width: 100%"
          stripe
          border
          size="small"
          @selection-change="handleSelectionChange"
        >
          <el-table-column type="selection" width="50"> </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            type="index"
            label="序号"
            width="50"
            :index="(index) => index + (currentPage - 1) * pageSize + 1"
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            label="活动类型"
            prop="gameType"
          >
            <template slot-scope="scope">
              {{ scope.row.gameType === "turntable" ? "大转盘" : "" }}
              {{ scope.row.gameType === "seckill" ? "秒杀" : "" }}
              {{ scope.row.gameType === "bargain" ? "砍价" : "" }}
              {{ scope.row.gameType === "bargains_team" ? "特价团" : "" }}
              {{ scope.row.gameType === "lottery_team" ? "抽奖团" : "" }}
              {{ scope.row.gameType === "collect_card" ? "集卡" : "" }}
              {{ scope.row.gameType === "leader_free_team" ? "团长免单团" : "" }}
              {{ scope.row.gameType === "integral_exchange" ? "积分兑换" : "" }}
              {{ scope.row.gameType === "single_single_exclusive" ? "单人单次专享" : ""}}
              {{ scope.row.gameType === "lucky_charm" ? "锦鲤活动" : "" }}
              {{ scope.row.gameType === "combination_set" ? "组合套餐活动" : "" }}
              {{ scope.row.gameType === "help_coupon" ? "助力劵" : "" }}
              {{ scope.row.gameType === "save_money_card" ? "省钱卡" : "" }}
              {{ scope.row.gameType === "password" ? "口令红包" : "" }}
              {{ scope.row.gameType === "red_envelope_rain" ? "红包雨" : "" }}
              {{ scope.row.gameType === "group" ? "拼团" : "" }}
            </template>
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="gameName"
            label="活动名称"
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="goodsNum"
            label="商品数量"
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="createTime"
            label="创建时间"
            width="150"
          ></el-table-column>
          <el-table-column
            width="280"
            header-align="center"
            align="center"
            prop="createTime"
            label="活动时间"
          >
            <template slot-scope="scope">
              {{ scope.row.gameStartTime }}至{{ scope.row.gameEndTime }}
            </template>
          </el-table-column>
        </el-table>
        <div class="hm-pagination mb20">
          <el-pagination
            background
            :total="goodsListTotal"
            @current-change="paging"
            @size-change="handleSizeChange"
            layout="total, sizes, prev, pager, next, jumper"
            :current-page="currentPage"
          ></el-pagination>
        </div>
      </div>
      <div class="table-wrapper" v-if="switchType==='groupList'">
        <div class="tips mb20">提示：点击表格行即可选择</div>
        <el-table
          @current-change="getCheckedEmployee2"
          highlight-current-row
          :data="groupList"
          key="groupList"
          style="width: 100%"
          stripe
          border
          size="small"
        >
          <el-table-column
            header-align="center"
            align="center"
            type="index"
            label="序号"
            width="50"
            :index="index => index + (currentPageGroup - 1) * pageSizeGroup + 1"
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            label="商品分组"
            prop="groupName"
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="relNum"
            label="商品数量"
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="createTime"
            label="创建时间"
          ></el-table-column>
        </el-table>
        <div class="hm-pagination mb20">
          <el-pagination
            background
            :total="groupListTotal"
            @current-change="pagingGroup"
            @size-change="handleSizeChangeGroup"
            layout="total, sizes, prev, pager, next, jumper"
            :current-page="currentPageGroup"
          ></el-pagination>
        </div>
      </div>
      </div>
      <div class="btn-wrapper mb20 flex flex-center" style="padding-bottom:20px">
        <el-button size="small" type="primary" @click="save">确 定</el-button>
        <el-button size="small" @click="close">取 消</el-button>
      </div>
  </el-dialog>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: "",
    },
    visible: {
      type: Boolean,
      default: false,
    }
  },
  components: {},
  data() {
    return {
      gameName: "",
      groupName:"",
      goodsList: [],
      goodsListTotal: 0,
      groupList: [],
      groupListTotal: 0,
      currentPage: 1,
      pageSize: 10,
      currentPageGroup: 1,
      pageSizeGroup: 10,
      switchType:"goodsList",
      currentRow: {},
      checkedCurrentRow: {},
    };
  },
  watch: {
  },
  created() {},
  mounted() {
    this.queryGoodsList();
  },
  methods: {
    handleSizeChange(size) {
      this.currentPage = 1;
      this.pageSize = size;
      this.queryGoodsList();
    },
    handleSizeChangeGroup(size) {
      this.currentPageGroup = 1;
      this.pageSizeGroup = size;
      this.queryGroupList();
    },
    handleCurrentChange(row) {
      // this.checkedCurrentRow = row;
    },
    getCheckedEmployee(selection) {
      // this.currentRow = [...selection];
    },
    getCheckedEmployee2(selection) {
      this.currentRow = selection;
    },
    handleSelectionChange(selection) {
      console.log("多选");
      console.log(selection);
      this.multipleRow = selection;
    },
    save() {
      if(this.switchType==='goodsList'){
        if (this.multipleRow.length == 0) {
          this.$message({
            type: "warning",
            message: "请先选择热销活动商品",
          });
        } else {
          this.$emit("saveHotGoods", this.multipleRow);
        }
      }else{
        if (!this.currentRow.groupId) {
          this.$message({
            type: "warning",
            message: "请先选择商品"
          });
        } else {
          this.$emit("saveGroupGoods", this.currentRow);
        }
      }
    },
    close() {
      this.$emit("close");
    },
    paging(page) {
      this.currentPage = page;
      this.queryGoodsList();
    },
    pagingGroup(page) {
      this.currentPage = page;
      this.queryGroupList();
    },
    async queryGoodsList() {
      console.log("queryHotSaleGameList");
      const { result } = await this.$store.dispatch("queryHotSaleGameList", {
        pageSize: this.pageSize,
        pageNo: this.currentPage,
        gameName: this.gameName,
      });
      const { records, total } = result;
      console.log(result);
      this.goodsList = records;
      this.goodsListTotal = total;
    },
    async queryGroupList() {
      const { result } = await this.$store.dispatch("queryGoodsGroupList", {
        pageSize: this.pageSize,
        pageNo: this.currentPage,
        groupName: this.groupName
      });
      const { records, total } = result;
      console.log(result);
      this.groupList = records;
      this.groupListTotal = total;
      console.log("this.groupList",this.groupList);
    },
    search() {
      this.currentPage = 1;
      if(this.switchType==='goodsList'){
        this.queryGoodsList();
      } else if (this.switchType === "groupList") {
        this.queryGroupList();
      }
    },
    switchTab() {
      this.currentPage = 1;
      this.pageSize = 10;
      this.currentPageGroup = 1;
      this.pageSizeGroup = 10;
      if (this.switchType === "goodsList") {
        this.queryGoodsList();
      } else if (this.switchType === "groupList") {
        this.queryGroupList();
      }
    },
  },
};
</script>
<style lang="scss" scoped></style>
